<div class="form-group">
  <ng-container [ngTemplateOutlet]="blockRenderer" [ngTemplateOutletContext]="{fieldGroups:fieldGroups}">
  </ng-container>
  @if (buttonConf) {
    <div class="col-sm-12 text-center mt-4 d-inline-block">
      <button type="button" (click)="cancelButtonClick()" class="secondary-btn">
        <img style="filter: grayscale(100%); margin-right: 5px;" src="assets/images/grid-back.png">
        {{'button.back' | translate | async}}
      </button>
    </div>
  }
</div>

<ng-template #blockRenderer let-fieldGroups='fieldGroups'>
  <span class="d-none">&nbsp;</span>
  @if (group_type != 'tab') {
    <div class="custom-block col-12 p-0 bg-white">
      @for (fieldg of fieldGroups ; track fieldg; let i = $index) {
        @if (fieldg['group_type']=='blocks' || fieldg['group_type']=='' || fieldg['group_type']=='accordian' || fieldg['group_type']=='scroll-tab') {
          <div [ngClass]="fieldg['group_type']=='blocks' ? 'col-12 p-0 kx-parent-block' : 'col-12 p-0 kx-child-block d-flex-inline'"
            [id]="fieldg['name']">
            @if (fieldg['title'] &&fieldg['visible'] ) {
              <div class="col-12 kx-block-sub-title">
                {{fieldg['title'] | translate | async}}
              </div>
            }
            <!-- <div class="form-group m-2"> -->
            @for (item of fieldg.questions; track item) {
              @if (!isArray(item) && (item.controlType != 'hidden' || (item.fire_dependent!=undefined && item.fire_dependent))  && item.controlType != 'button' && (item.visible==true||item.visible=='true')) {
                <dhs-form-view-item (valueChanged)="onValueChanged($event)" [item]="item" [current_action]="action" class="kx-control col-12" [ngClass]="( item.controlType=='dynamic-table' || item.controlType=='composite-array' || item.controlType=='html-editor' ||item.controlType=='formwithgrid' || item.controlType=='editable-table' || item.controlType=='pullable' || item.controlType=='editgrid' ||item.controlType=='annotation'||item.controlType=='subHeading' || item.controlType=='tickets' ) ? 'col-12' : ((item.controlType=='textarea') ? item.className : 'col-sm-6 col-md-4 col-lg-4 col-xl-4')"
                  [data]="data">
                </dhs-form-view-item>
              }
              @if (isArray(item)) {
                @if (item.label && fieldg['visible']) {
                  <div class="col-12 mb-3 font-weight-bold sub-h">
                    {{item.label | translate | async}}
                  </div>
                }
                <ng-container [ngTemplateOutlet]="blockRenderer" [ngTemplateOutletContext]="{fieldGroups:item}">
                </ng-container>
              }
            }
            @if (fieldg.fields) {
              <dhs-score [fields]="fieldg.fields" [scoreData]="fieldg.scoreData" [blockId]="fieldg.block_id" [blockName]="fieldg.title" (valueAdded)="scoreEvent($event);" [data]="data" [current_action]="action"></dhs-score>
            }
          <!-- </div> -->
        </div>
      }
      <!-- For Accordian -->
      <!-- <div class="row" *ngIf="fieldg['group_type']=='accordian'&&fieldg['visible']">
      <div class="col-12">
        <div id="accordion{{i}}" class="accordion">
          <div class="collapsed kx-accordion-header" data-toggle="collapse" [attr.data-target]="'#acc'+i">
            <a class="kx-accordion-title">
              {{fieldg['title'] | translate | async}}
            </a>
          </div>
          <div id="acc{{i}}" class="kx-collapse-body collapse" [attr.data-parent]="'#accordion'+i">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12 p-3">
              <div class="row">
                <ng-container *ngFor="let item of fieldg.questions">
                  <ng-container *ngIf="!isArray(item) && item.controlType != 'hidden'">
                    <dhs-form-view-item (valueChanged)="onValueChanged($event)"  class="kx-control col-12" [ngClass]="item.controlType=='composite-array' || item.controlType=='html-editor'?'col-12':'col-sm-6 col-md-4 col-lg-4 col-xl-4'"  [item]="item" [data]="data">
                    </dhs-form-view-item>
                  </ng-container>
                  <ng-container *ngIf="isArray(item)">
                    <div class=" composite_block" *ngIf="item.label">{{item.label | translate | async}}
                    </div>
                    <ng-container [ngTemplateOutlet]="blockRenderer" [ngTemplateOutletContext]="{fieldGroups:item}">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  }
</div>
}
</ng-template>